import React, { useState, useEffect } from 'react';
import {
	Container,
	Button,
	Form,
	Row,
	Col,
	FormControl,
	InputGroup,
} from 'react-bootstrap';

import '../../../assets/css/AddNewJob.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { PlusCircleIcon } from '@primer/octicons-react';
import { HorizontalRuleIcon } from '@primer/octicons-react';
import {
	getLocation,
	getLocationDetailByPlaceId,
} from '../../../config/Requests';
import { Multiselect } from 'multiselect-react-dropdown';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { showLoader, hideLoader } from '../../../helper/loader';
import { ReqGet, ReqPatch } from '../../../config/Requests';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header, Footer } from '../../Container';
import { MdInfo } from 'react-icons/md';
import moment from 'moment';
import Select from 'react-select';
import SuggestTags from '../SuggestTags';
import { useParams } from 'react-router-dom';
import { formattedTags } from '../../../helper/utils';
import { dateFormatter } from '../../../helper/dateFormater';
import { AiFillTags } from 'react-icons/ai';

import { BsBookmarkCheck } from 'react-icons/bs';
import { RxCrossCircled } from 'react-icons/rx';
import { ImCross } from 'react-icons/im';
import { remove } from 'lodash';
import ParentTagsScreen from './ParentTags';
import NewChildTag from './NewChildTag';
import ChildTagsDraftScreen from './childTagDraft';
import { toast } from 'react-toastify';
import { Stack } from '@mui/material';
function EditJob() {
	let navigate = useNavigate();
	const { id } = useParams();
	const [showTooltip, setShowTooltip] = useState(false);
	const [loaded, setLoaded] = useState(false);
	const [data, setJob] = useState({});
	const [showChildTag, setShowChildTag] = useState(false);
	const [parentTag, setParentTag] = useState(null);
	const [childTags, setChildTags] = useState([]);
	const [childTags2nd, setChildTags2nd] = useState([]);
	const [initialValues, setInitialValues] = useState({});
	const [tools, setTools] = useState(['']);
	const [otherRequirements, setOtherRequirements] = useState(['']);
	const [expertise, setExpertise] = useState(['']);
	const [parentShow, setParentShow] = useState(false);

	const [childrenShow, setChildrenShow] = useState(false);
	const [selectedChild, setSelectedChild] = useState([]);
	const [selectedChild2nd, setSelectedChild2nd] = useState([]);
	const [childSelected, setChildSelected] = useState([]);
	const [show, setShow] = useState(true);
	const [childrenTags, setChildrenTags] = useState([]);
	const [activeList, setActiveList] = useState([]);
	const [parent, setParent] = useState('');
	const [manager, setManager] = useState({
		full_name: '',
		phone_number: '',
		email: '',
	});
	//
	const [selectedParent, setSelectredParent] = useState([]);
	const [selectedParent2, setSelectredParent2] = useState([]);
	const [selectedChild2, setSelectedChild2] = useState([]);
	const [selectedChild3, setSelectedChild3] = useState([]);
	const [childTags2, setChildTags2] = useState([]);
	const [childTags3, setChildTags3] = useState([]);
	const [checked1, setChecked1] = useState([]);
	const [childChecked, setChildChecked] = useState([]);
	const [childChecked2nd, setChildChecked2nd] = useState([]);
	const [childChecked2, setChildChecked2] = useState([]);
	const [childChecked3, setChildChecked3] = useState([]);
	const [checked2, setChecked2] = useState([]);
	const [overtime, setOvertime] = useState(false);

	const today = new Date();
	let currentDate = new Date(
		today.getFullYear(),
		today.getMonth(),
		today.getDate(),
		0,
		0,
		0
	);
	const days = 15;
	currentDate = currentDate.setDate(currentDate.getDate() + days);
	currentDate = new Date(currentDate);
	let todayDate = new Date();
	todayDate = dateFormatter(todayDate, 'YYYY-MM-DD');
	const validationSchema = Yup.object().shape({
		title: Yup.string()
			.required('*Title is required')
			.max(100, 'Title should not be more than 100 characters')
			.min(3, 'Title should contain at least 3 characters'),
		description: Yup.string().required('*Description is required'),
		// specific_qualification: Yup.string()
		//   .required("*Specific Qualification is required"),
		start_pay_range: Yup.number()
			.positive('Must be positive number')
			.required('*This field is required'),
		end_pay_range: Yup.number()
			.positive('Must be positive number')
			.required('*This field is required')
			.min(
				Yup.ref('start_pay_range'),
				'Max Pay rate must be greater then starter'
			),
		// Location: Yup.string()
		//   .required("*This field is required"),
		// remote_job: Yup.string()
		//   .required("*This field is required"),
		job_type: Yup.string().required('*Job type is required'),
		worker_type: Yup.string().required('*worker type is required'),
		start_date: Yup.date().required('*This field is required'),
		// .min(new Date(currentDate),"Start Date must be Greater then 15 Days of Current Date"),
		end_date: Yup.date()
			.required('*This field is required')
			.min(Yup.ref('start_date'), 'end date must be greater than start date'),
		priority: Yup.string().required('Priority Level is required'),
		manager_name: Yup.string().required('*manager name is required'),
		manager_email: Yup.string().required('*manager email is required'),
		manager_phone: Yup.string().required('*manager phone number is required'),
	});

	const [tags, setTags] = useState([]);
	const [chosenTags, setChosenTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [returnedTags, setReturnedTags] = useState([]);

	useEffect(() => {
		let selected = [];

		tags.map(tag => {
			tag.child_tags.map(child => {
				if (chosenTags.includes(child.id)) {
					selected = [
						...selected,
						{ label: child.display_name, value: child.id, id: child.id },
					];
				}
			});
		});

		setSelectedTags(selected);
		setSelectedChild(selected);
		setActiveList([...selected]);
		// selectedChild.filter((d1) => d1.value != d3.value)
	}, [chosenTags]);
	// chosenTags.filter((d1) => setActiveList([...activeList,d1.id]))
	useEffect(() => {
		if (tags.length === 0) return;

		let returnedTags = formattedTags(tags);
		setReturnedTags(returnedTags);

		data?.tags && setSelectedTags(formatSelectedTags(data?.tags));
		data?.tags && setChosenTags(data?.tags?.map(tag => tag.id));
	}, [tags, data]);

	useEffect(() => {
		// showLoader();
		ReqGet('tags')
			.then(res => {
				setTags(res.data.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data.status) {
					setJob({ ...data.data });
					setInitialValues({ ...data.data });
					setOtherRequirements(data?.data?.other_requirements);
					setTools(data?.data?.tool);
					setExpertise(data?.data?.specific_expertise);
					// hideLoader();
					setLoaded(true);
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	const [locations, setLocations] = useState([]);

	const formatSelectedTags = items => {
		let changedTags = [];
		if (!items) return [];

		items.map((item, i) => {
			changedTags.push({
				label: item.display_name,
				value: item.id,
				id: item.id,
			});
		});

		return changedTags;
	};

	const handleLocationSearch = (keyword, cb) => {
		getLocation(keyword).then(res => {
			cb(res?.data?.predictions);
		});
	};

	const handleLocationChange = (obj, setFieldValue) => {
		if (obj && obj.length > 0) {
			getLocationDetailByPlaceId(obj[0].place_id).then(response => {
				const res = response.data.results[0];
				if (res) {
					setFieldValue('address', res.formatted_address);
					setFieldValue('location_lat', res.geometry.location.lat);
					setFieldValue('location_lng', res.geometry.location.lng);
				}
			});
		}
	};
	//states and city
	const [statesData, setStatesData] = useState([]);
	const [citiesData, setCitiesData] = useState([]);

	useEffect(() => {
		//get states
		ReqGet('states')
			.then(res => {
				setStatesData(res.data);
				const state_id = data.job_state || res?.data[0]?.id;

				//call cities api
				if (state_id) {
					ReqGet('cities/' + state_id)
						.then(res => {
							console.log(statesData);
							setCitiesData(res.data);
						})
						.catch(err => {
							console.log(err.message);
						});
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, [data]);

	const loadcities = (id, setFieldValue) => {
		ReqGet('cities/' + id)
			.then(res => {
				setCitiesData(res.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		setFieldValue('job_state', id);
	};
	///
	// const selectParentTag = (d1) => {

	//   setParent(d1.label);
	//   ReqGet(`child-tags/${d1.value}`)
	//     .then((res) => {
	//       setChildTags(formattedTags(res.data.data));
	//     })
	//     .catch((err) => {
	//       console.log(err.message);
	//     });
	//   setParentShow(false);
	//   setChildrenShow(true);
	// };

	// const childSelection = (e) => {
	//   const { value, checked } = e.target;

	//   let d3 = JSON.parse(e.target.value);
	//   console.log(value,checked,"d3333333",d3)
	//   d3 = { ...d3, parent: parent };
	//   if (!checked) {
	//     setActiveList(activeList.filter((d1) => d1.value != d3.value));
	//     return setSelectedChild(
	//       selectedChild.filter((d1) => d1.value != d3.value)
	//     );
	//   }

	//   // selectRow
	//   setActiveList([...activeList, d3]);
	//   setSelectedChild([...selectedChild, d3]);
	// };

	const okFun = () => {
		if (selectedChild.length < 1) {
			toast.error(`Please select atleast 1 children tag`);

			return;
		}
		setChildrenShow(false);
		// setSelectedChild([])
		setChildSelected([...selectedChild]);
	};

	const showParent = () => {
		setParentShow(true);
		setChildrenShow(false);
	};
	const removeTag = id => {
		setChildSelected(childSelected.filter(d2 => d2.value != id));
		setSelectedChild(selectedChild.filter(d1 => d1.value != id));

		setActiveList(activeList.filter(d1 => d1.value != id));
	};

	const hideParentTag = () => {
		setParentShow(false);
	};
	const hideChildrenTag = tag1 => {
		if (selectedChild.length < 1 && tag1 !== 'cross') {
			toast.error(`Please select at least 1 Child Tag`);
		}
		setChildrenShow(false);
	};
	// 1st Parent
	const selectParentTag = (e, d1) => {
		const { checked, value } = e.target;
		console.log(d1, 'helloooo');
		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent([d1]);
			setChecked1([d1.value]);
		} else {
			setSelectredParent([]);
			setChecked1([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags(formattedTags(res.data.data));
					setChildTags2nd(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags([]);
			setChildTags2nd([]);
			setChildChecked([]);
			setChildChecked2nd([]);
			setSelectedChild([]);
			setSelectedChild2nd([]);
		}
		setChildChecked([]);
		setChildChecked2nd([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	// 2nd Parent
	const selectParentTag2 = (e, d1) => {
		const { checked, value } = e.target;

		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent2([d1]);
			setChecked2([d1.value]);
		} else {
			setSelectredParent2([]);
			setChecked2([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags2(formattedTags(res.data.data));
					setChildTags3(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags2([]);
			setChildTags3([]);
			setChildChecked2([]);
			setChildChecked3([]);
			setSelectedChild2([]);
			setSelectedChild3([]);
		}
		setChildChecked2([]);
		setChildChecked3([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	//1st Child

	const childSelection = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked([...childChecked, result.value]);
			setSelectedChild([...selectedChild, result]);
		} else {
			let f1 = [...selectedChild];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild([...f1]);
		}
		// const { value, checked } = e.target;
		// let d3 = JSON.parse(e.target.value);
		// d3 = { ...d3, parent: parent };
		// if (!checked) {
		//   setActiveList(activeList.filter((d1) => d1 != d3.value));
		//   return setSelectedChild(
		//     selectedChild.filter((d1) => d1.value != d3.value)
		//   );
		// }

		// // selectRow
		// setActiveList([...activeList, d3.value]);
		// setSelectedChild([...selectedChild, d3]);
	};

	// 2nd child
	const childSelection2nd = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2nd([...childChecked2nd, result.value]);
			setSelectedChild2nd([...selectedChild2nd, result]);
		} else {
			let f1 = [...selectedChild2nd];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2nd];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2nd(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild2nd([...f1]);
		}
	};

	/// 3rd child
	const childSelection2 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2([...childChecked2, result.value]);
			setSelectedChild2([...selectedChild2, result]);
		} else {
			let f1 = [...selectedChild2];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2(checkCild);

			return setSelectedChild2([...f1]);
		}
	};
	// 4th child
	const childSelection3 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked3([...childChecked3, result.value]);
			setSelectedChild3([...selectedChild3, result]);
		} else {
			let f1 = [...selectedChild3];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked3];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked3(checkCild);

			return setSelectedChild3([...f1]);
		}
	};

	////
	const formSubmit = values => {
		const getChild = [];
		if (selectedChild.length < 1) {
			toast.error(`Please select atleast 1 children tag`);
			return;
		}
		selectedChild.filter(d1 => getChild.push(d1.value));
		const params = {
			...values,
			tags: getChild,
			tool: tools,
			specific_expertise: expertise,
			other_requirements: otherRequirements,
		};
		// showLoader();
		ReqPatch(`jobs/${data.id}`, params)
			.then(res => {
				if (res.status === 200) {
					if (params.published) {
						navigate(`/job-post-success`);
					} else {
						navigate(`/job-draft-success`);
					}
				} else {
					toast.error(res.data.message);
				}
			})
			.catch(err => {
				console.log(err.response);
			});
		// .finally(hideLoader());
	};

	const loadChildTags = tag_parent_id => {
		ReqGet(`child-tags/${tag_parent_id}`)
			.then(res => {
				setChildTags(formattedTags(res.data.data));
			})
			.catch(err => {
				console.log(err.message);
			});
	};

	const handleButtonClick = submitForm => {
		submitForm();
	};

	const handleChangeMultiInput = (e, index, items, setItems) => {
		const { value } = e.target;
		const list = [...items];
		list[index] = value;
		setItems(list);
	};

	const handleRemove = (index, items, setItem) => {
		const list = [...items];
		list.splice(index, 1);
		setItem(list);
	};

	const selectTags = tags => {
		let selected = [];
		tags.map((data, i) => {
			selected.push(data.value);
		});
		setChosenTags(selected);
		console.log(selected, 'chosen111111', chosenTags);
	};
	const overtimeTravel = e => {
		console.log(e.target.value, 'eee', e.target.checked);
		initialValues.overtime = e.target.checked;
		setOvertime(e.target.checked);
		console.log(initialValues.overtime, 'b');
	};
	// css
	const iconStyle = {
		cursor: 'pointer',
		width: '80%',
		height: '0%',
	};

	const tooltipStyle = {
		position: 'absolute',
		bottom: '100%',
		left: '50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#333',
		color: '#fff',
		padding: '5px',
		borderRadius: '5px',
		width: '742%',
		display: showTooltip ? 'block' : 'none',
	};
	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='add-new-job'>
				{/* <Row>
          <Col>
            <div className="mt-2 mb-3 recruiter_actions" />
            <div className={"top-actions"}>
              <h4 className={"text-orange"}>Edit job opportunity</h4>
            </div>
          </Col>
        </Row> */}
				<Row>
					<Col>
						{loaded ? (
							<Formik
								initialValues={initialValues}
								validationSchema={validationSchema}
								onSubmit={(values, { setSubmitting, resetForm }) => {
									formSubmit(values, setSubmitting, resetForm);
								}}
							>
								{({
									errors,
									touched,
									values,
									handleChange,
									setFieldValue,
									submitForm,
								}) => (
									<Form>
										<Form style={{ border: '1px solid', marginTop: '12px' }}>
											<Row>
												<Col sm={12}>
													<div
														className={'top-actions bg-label'}
														style={{ borderBottom: ' 1px solid' }}
													>
														<h4
															className={
																'heading text-orange fw-bold p-2 ms-2 rounded'
															}
														>
															Edit Job Opportunity
														</h4>
													</div>
												</Col>
											</Row>
											{/* Priority Level */}

											<Row style={{ marginLeft: '4px' }}>
												<h4 className={'heading fw-bold p-2 ms-2 rounded mb-2'}>
													Administrative Data
												</h4>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Priority Level
																{/* <span style={{ color: "red" }}>*</span> */}
															</InputGroup.Text>
														</>

														<Form.Control
															as='select'
															custom
															name='priority'
															onChange={handleChange}
															placeholder='Select Level'
															required
															value={values.priority}
														>
															<option value='high'> High </option>
															<option value='medium'> Medium </option>
															<option value='standard'> Low </option>
														</Form.Control>
													</InputGroup>
												</Col>

												{/*  Security Clearance*/}
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text
																className='fw-bold'
																style={{ width: '270px' }}
															>
																Security Clearance Required
																{/* <span style={{ color: "red" }}>*</span> */}
																<Form.Check
																	size='lg'
																	style={{ marginLeft: '10px' }}
																	custom
																	inline
																	type='switch'
																	id='secrurity-clearance'
																	name='security_clearance'
																	label=' '
																	checked={
																		values.security_clearance ? true : false
																	}
																	onChange={() =>
																		setFieldValue(
																			'security_clearance',
																			!values.security_clearance
																		)
																	}
																/>
															</InputGroup.Text>
														</>

														<Form.Group
															controlId='newJobDestination'
															className='ms-1'
														>
															{values.security_clearance ? (
																<Form.Group controlId='newJobDestination'>
																	<div key={`custom-inline-checkbox`}>
																		<label className='radiobox-flex'>
																			<Field
																				type='radio'
																				className='radiobox'
																				name='security_level'
																				value='1'
																				onChange={handleChange}
																				id='itar'
																			/>
																			<span> ITAR </span>
																		</label>

																		<label className='radiobox-flex'>
																			<Field
																				type='radio'
																				className='radiobox'
																				name='security_level'
																				value='2'
																				onChange={handleChange}
																				id='secret'
																			/>
																			<span> Secret </span>
																		</label>

																		<label className='radiobox-flex'>
																			<Field
																				type='radio'
																				className='radiobox'
																				name='security_level'
																				value='3'
																				onChange={handleChange}
																				id='top-secret'
																			/>
																			<span> Top Secret </span>
																		</label>

																		{errors.security_level &&
																		touched.security_level ? (
																			<div className={`red mb-1 fs15`}>
																				{errors.security_level}
																			</div>
																		) : null}
																	</div>
																</Form.Group>
															) : (
																''
															)}
														</Form.Group>
													</InputGroup>
												</Col>
												<Col sm={6} style={{ marginTop: '18px' }}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															No. of Positions
															{/* <span style={{ color: "red" }}>*</span> */}
														</InputGroup.Text>

														<Form.Control
															onChange={handleChange}
															type='Number'
															min='0'
															oninput='this.value = Math.abs(this.value)'
															value={values.max_applicants}
															name='max_applicants'
															rows='1'
															className={`${
																errors.max_applicants && touched.max_applicants
																	? 'error'
																	: ''
															}`}
															placeholder='Enter No. of Positions'
														/>
														{errors.max_applicants && touched.max_applicants ? (
															<div className={`red mb-1 fs15`}>
																{errors.max_applicants}
															</div>
														) : null}
													</InputGroup>
												</Col>
											</Row>

											{/* No. of Positions */}

											{/* Date */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Date{' '}
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12}>
													<Form.Group className='pl-5 mt-4 pb-3'>
														<Stack direction={'row'} gap={2}>
															<Col xs='auto'>
																{' '}
																<Form.Label className='mt-2'>
																	{' '}
																	Start Date:{' '}
																</Form.Label>{' '}
															</Col>
															<Col sm md={4}>
																<FormControl
																	placeholder='Select Start Date'
																	aria-label='Username'
																	aria-describedby='basic-addon1'
																	type='date'
																	onChange={handleChange}
																	value={values.start_date}
																	name='start_date'
																	min={todayDate}
																	max={values.end_date}
																/>
																{errors.start_date && touched.start_date ? (
																	<div className={`red mb-1 fs15`}>
																		{errors.start_date}
																	</div>
																) : null}
															</Col>
															<Col md={1} className='ms-5 mt-1'>
																<div
																	style={{
																		position: 'relative',
																		display: 'inline-block',
																	}}
																>
																	<MdInfo
																		style={iconStyle}
																		onMouseEnter={() => setShowTooltip(true)}
																		onMouseLeave={() => setShowTooltip(false)}
																	/>
																	<div style={tooltipStyle}>
																		Start date must be Greater <br /> than 15
																		Days of Current day
																	</div>
																</div>
															</Col>

															<Col xs='auto'>
																{' '}
																<Form.Label className='mt-2'>
																	{' '}
																	End Date:{' '}
																</Form.Label>{' '}
															</Col>
															<Col sm md={4}>
																<FormControl
																	placeholder='Select Start Date'
																	aria-label='Username'
																	aria-describedby='basic-addon1'
																	type='date'
																	onChange={handleChange}
																	value={values.end_date}
																	name='end_date'
																	min={values.start_date}
																/>
																{errors.end_date && touched.end_date ? (
																	<div className={`red mb-1 fs15`}>
																		{errors.end_date}
																	</div>
																) : null}
															</Col>
														</Stack>
													</Form.Group>
												</Col>
											</Row>

											{/* Job Requesting Manager */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Job Requesting Manager{' '}
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
													marginBottom: '15px',
												}}
											>
												<Col sm={12}>
													<ul className='list-group list-group-flush'>
														<li className='list-group-item fw-bold'>
															{/* {references.map((item, i) => { */}

															<InputGroup
																controlId='formBasicEmail'
																className='mb-4 mt-2'
															>
																<>
																	<InputGroup.Text className='fw-bold'>
																		Full Name
																		<span style={{ color: 'red' }}>*</span>
																	</InputGroup.Text>
																</>
																<Form.Control
																	maxlength='30'
																	name='manager_name'
																	onChange={handleChange}
																	type='text'
																	placeholder='Enter Full Name'
																	// defaultValue={manager.full_name}
																	value={values.manager_name}
																/>
																{errors.manager_name && touched.manager_name ? (
																	<div
																		className={`red mb-1 fs15`}
																		style={{ fontWeight: '400' }}
																	>
																		{errors.manager_name}
																	</div>
																) : null}
															</InputGroup>

															<Row>
																<Col sm={6}>
																	<InputGroup
																		controlId='formBasicEmail'
																		className='mb-4'
																	>
																		<>
																			<InputGroup.Text className='fw-bold'>
																				Email
																				<span style={{ color: 'red' }}>*</span>
																			</InputGroup.Text>
																		</>
																		<Form.Control
																			name='manager_email'
																			onChange={handleChange}
																			type='text'
																			placeholder='Enter Email Address'
																			// defaultValue={manager.email}
																			value={values.manager_email}
																		/>
																		{errors.manager_email &&
																		touched.manager_email ? (
																			<div
																				className={`red mb-1 fs15`}
																				style={{ fontWeight: '400' }}
																			>
																				{errors.manager_email}
																			</div>
																		) : null}
																	</InputGroup>
																</Col>
																<Col sm={6}>
																	<InputGroup
																		controlId='formBasicEmail'
																		className='mb-2'
																	>
																		<>
																			<InputGroup.Text className='fw-bold'>
																				Phone Number
																				<span style={{ color: 'red' }}>*</span>
																			</InputGroup.Text>
																		</>
																		<Form.Control
																			maxlength='50'
																			name='manager_phone'
																			onChange={handleChange}
																			type='text'
																			placeholder='Enter Phone Number'
																			// defaultValue={manager.phone_number}
																			value={values.manager_phone}
																		/>
																		{errors.manager_phone &&
																		touched.manager_phone ? (
																			<div
																				className={`red mb-1 fs15`}
																				style={{ fontWeight: '400' }}
																			>
																				{errors.manager_phone}
																			</div>
																		) : null}
																	</InputGroup>
																</Col>
															</Row>

															{/* }) */}
														</li>
													</ul>
												</Col>
											</Row>
										</Form>
										{/*Job Profile  */}
										<Form style={{ border: '1px solid', marginTop: '12px' }}>
											<Row>
												<Col sm={12}>
													<div
														className={'top-actions bg-label'}
														style={{ borderBottom: ' 1px solid' }}
													>
														<h4
															className={
																'heading text-orange fw-bold p-2 ms-2 rounded'
															}
														>
															Job Profile
														</h4>
													</div>
												</Col>
											</Row>
											{/* Priority Level */}

											<h4 className={'heading fw-bold p-2 ms-2 rounded'}>
												General Data
											</h4>
											<Row style={{ marginLeft: '4px' }}>
												{/* Job ID # */}
												<Col sm={4}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Job ID #:
																<span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>
														</>

														<Form.Control
															onChange={handleChange}
															value={values.job_id}
															maxlength='70'
															name='job_id'
															rows='1'
															className={`${
																errors.job_id && touched.tijob_idtle
																	? 'error'
																	: ''
															}`}
															placeholder='Enter Job Id here'
														/>
														{errors.job_id && touched.job_id ? (
															<div className={`red mb-1 fs15`}>
																{errors.job_id}
															</div>
														) : null}
													</InputGroup>
												</Col>

												{/* Job Title */}
												<Col sm={7}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Job Title:
																<span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>
														</>
														<Form.Control
															onChange={handleChange}
															value={values.title}
															name='title'
															rows='1'
															className={`${
																errors.title && touched.title ? 'error' : ''
															}`}
															as='textarea'
															placeholder='Enter title here'
														/>
														{errors.title && touched.title ? (
															<div className={`red mb-1 fs15`}>
																{errors.title}
															</div>
														) : null}
													</InputGroup>
												</Col>
											</Row>

											{/* Worker Type */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Worker Type <span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12}>
													<Form.Group
														controlId='newJobDestination'
														className='mt-4 '
													>
														<Stack
															direction={'row'}
															gap={2}
															key={`custom-inline-checkbox`}
															className='ms-5 mb-3'
														>
															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='worker_type'
																	value='1099-subcontractor'
																	onChange={handleChange}
																/>
																<span> 1099 Subcontractor </span>
															</label>

															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='worker_type'
																	value='w2-contingent-worker'
																	onChange={handleChange}
																/>
																<span> W2 Contingent Worker </span>
															</label>

															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='worker_type'
																	value='contingent-to-full-time-employee'
																	onChange={handleChange}
																/>
																<span> W-2 Contingent to Direct Hire </span>
															</label>

															<label className='radiobox-flex'>
																<Field
																	name='worker_type'
																	onChange={handleChange}
																	value='direct-hire-only'
																	type={`radio`}
																	id={`job-type-direct-dire-only`}
																/>
																<span> Direct Hire Only </span>
															</label>

															{errors.job_type && touched.job_type ? (
																<div className={`red mb-1 fs15`}>
																	{errors.job_type}
																</div>
															) : null}
														</Stack>
													</Form.Group>
												</Col>
											</Row>
											{/* Job Type */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Job Type <span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12}>
													<Form.Group
														controlId='newJobDestination'
														className='ms-5 mt-4 mb-3'
													>
														<Stack
															key={`custom-inline-checkbox`}
															direction={'row'}
															gap={2}
														>
															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='job_type'
																	value='fullTime'
																	onChange={handleChange}
																/>
																<span> Full Time </span>
															</label>

															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='job_type'
																	value='halfTime'
																	onChange={handleChange}
																/>
																<span> Half Time </span>
															</label>

															<label className='radiobox-flex'>
																<Field
																	type='radio'
																	className='radiobox'
																	name='job_type'
																	value='both'
																	onChange={handleChange}
																/>
																<span> Full & Half time </span>
															</label>

															{errors.job_type && touched.job_type ? (
																<div className={`red mb-1 fs15`}>
																	{errors.job_type}
																</div>
															) : null}
														</Stack>
													</Form.Group>
												</Col>
											</Row>
											{/* Job Location */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Job Location <span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
													marginBottom: '16px',
												}}
											>
												<Col sm={12} style={{ marginBottom: '15px' }}>
													<Row style={{ marginTop: '15px' }}>
														<Col sm={6}>
															<InputGroup controlId='formBasicEmail'>
																<>
																	<InputGroup.Text className='fw-bold'>
																		State:
																		<span style={{ color: 'red' }}>*</span>
																	</InputGroup.Text>
																</>
																<Form.Control
																	as='select'
																	value={values.job_state}
																	custom
																	name='job_state'
																	onChange={event =>
																		loadcities(
																			event.target.value,
																			setFieldValue
																		)
																	}
																	placeholder='Select State'
																	required
																>
																	<option value=''>Select State</option>
																	return(
																	{statesData.map((item, i) => {
																		return (
																			<option key={i} value={item.id}>
																				{item.name}
																			</option>
																		);
																	})}
																	)
																</Form.Control>
																{errors.job_state && touched.job_state ? (
																	<div className={`red mb-1 fs15`}>
																		{errors.job_state}
																	</div>
																) : null}
															</InputGroup>
														</Col>
														<Col sm={6}>
															<InputGroup controlId='formBasicEmail'>
																<>
																	<InputGroup.Text className='fw-bold'>
																		City <span style={{ color: 'red' }}>*</span>
																	</InputGroup.Text>
																</>
																<Form.Control
																	onChange={handleChange}
																	value={values.city}
																	maxlength='70'
																	name='city'
																	rows='1'
																	className={`${
																		errors.city && touched.city ? 'error' : ''
																	}`}
																	placeholder='Enter city here'
																/>
																{errors.city && touched.city ? (
																	<div className={`red mb-1 fs15`}>
																		{errors.city}
																	</div>
																) : null}
															</InputGroup>
														</Col>
													</Row>
												</Col>
											</Row>
										</Form>

										{/* Job Specifications */}

										<Form style={{ border: '1px solid', marginTop: '12px' }}>
											<Row>
												<Col sm={12}>
													<div
														className={'top-actions bg-label'}
														style={{ borderBottom: ' 1px solid' }}
													>
														<h4
															className={
																'heading text-orange fw-bold p-2 ms-2 rounded'
															}
														>
															Job Specifications
														</h4>
													</div>
												</Col>
											</Row>
											{/* Year Experience */}
											<Col
												sm={6}
												style={{
													// marginTop: '8px',
													width: '97.5%',
													marginLeft: '18px',
													marginBottom: '14px',
												}}
											>
												<InputGroup controlId='formBasicEmail' className='mb-4'>
													<>
														<InputGroup.Text className='fw-bold'>
															Years Experience:
															<span style={{ color: 'red' }}>*</span>
														</InputGroup.Text>
													</>
													<Form.Control
														as='select'
														custom
														name='year_experience'
														onChange={handleChange}
														required
														value={values?.year_experience}
													>
														<option disabled selected>
															Select Year Experience
														</option>
														<option value='1-3'>1-3</option>
														<option value='4-6'>4-6</option>
														<option value='7-10'>7-10</option>
														<option value='10+'>10+</option>
													</Form.Control>
												</InputGroup>
											</Col>
											{/* Pay Rate Range */}
											<Row style={{ marginLeft: '4px' }}>
												{/* Job ID # */}
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Hourly Pay Rate Range
																<span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>
															<InputGroup.Text className='fw-bold'>
																Low End
															</InputGroup.Text>
														</>
														<Form.Control
															value={values.start_pay_range}
															onChange={handleChange}
															name='start_pay_range'
															type='text'
															min='0'
															// oninput="this.value = Math.abs(this.value)"
															onInput={e => {
																e.target.value = e.target.value.replace(
																	/[^0-9\.]/g,
																	''
																);
															}}
															className={`${
																errors.start_pay_range &&
																touched.start_pay_range
																	? 'error'
																	: ''
															}`}
															placeholder={'From'}
														/>
														{errors.start_pay_range &&
														touched.start_pay_range ? (
															<div className={`red mb-1 fs15`}>
																{errors.start_pay_range}
															</div>
														) : null}
													</InputGroup>
												</Col>
												<Col sm={1}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																To
															</InputGroup.Text>
														</>
													</InputGroup>
												</Col>
												<Col sm={4}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																High End
															</InputGroup.Text>
														</>

														<Form.Control
															min={values.start_pay_range}
															value={values.end_pay_range}
															onChange={handleChange}
															name='end_pay_range'
															type='text'
															onInput={e => {
																e.target.value = e.target.value.replace(
																	/[^0-9\.]/g,
																	''
																);
															}}
															className={`${
																errors.end_pay_range && touched.end_pay_range
																	? 'error'
																	: ''
															}`}
															placeholder={'To'}
														/>
														{errors.end_pay_range && touched.end_pay_range ? (
															<div className={`red mb-1 fs15`}>
																{errors.end_pay_range}
															</div>
														) : null}
													</InputGroup>
												</Col>
												{/*  */}
												<Col
													className='fw-bold p-1 mt-3 rounded'
													style={{ marginLeft: '12px' }}
												>
													{' '}
													<InputGroup
														controlId='formBasicEmail'
														style={{ width: '98%' }}
													>
														<>
															<InputGroup.Text className='fw-bold'>
																Overtime
																<Form.Check
																	size='lg'
																	custom
																	inline
																	name='overtime'
																	onChange={overtimeTravel}
																	type='switch'
																	id='custom-switch1'
																	label=''
																	className='ms-2'
																/>
															</InputGroup.Text>
														</>
													</InputGroup>
													{overtime ? (
														<Form.Group
															controlId='newJobDestination'
															className='mt-3'
														>
															<Row>
																<Col sm={6}>
																	<InputGroup controlId='formBasicEmail'>
																		<>
																			<InputGroup.Text className='fw-bold'>
																				Hourly Pay Rate Range
																			</InputGroup.Text>
																			<InputGroup.Text className='fw-bold'>
																				Low End
																			</InputGroup.Text>
																		</>

																		<Form.Control
																			value={values.start_pay_range1}
																			onChange={handleChange}
																			name='start_pay_range'
																			type='text'
																			min='0'
																			onInput={e => {
																				e.target.value = e.target.value.replace(
																					/[^0-9\.]/g,
																					''
																				);
																			}}
																			inputMode='numeric'
																			className={`${
																				errors.start_pay_range1 &&
																				touched.start_pay_range1
																					? 'error'
																					: ''
																			}`}
																			placeholder={'From'}
																		/>
																	</InputGroup>
																</Col>
																<Col sm={1}>
																	<InputGroup controlId='formBasicEmail'>
																		<>
																			<InputGroup.Text className='fw-bold'>
																				To
																			</InputGroup.Text>
																		</>
																	</InputGroup>
																</Col>
																<Col sm={5}>
																	<InputGroup
																		controlId='formBasicEmail'
																		style={{ width: '93%' }}
																	>
																		<>
																			<InputGroup.Text className='fw-bold'>
																				High End
																			</InputGroup.Text>
																		</>
																		<Form.Control
																			min={values.start_pay_range}
																			value={values.end_pay_range1}
																			onChange={handleChange}
																			name='end_pay_range'
																			type='text'
																			onInput={e => {
																				e.target.value = e.target.value.replace(
																					/[^0-9\.]/g,
																					''
																				);
																			}}
																			className={`${
																				errors.end_pay_range1 &&
																				touched.end_pay_range1
																					? 'error'
																					: ''
																			}`}
																			placeholder={'To'}
																		/>
																	</InputGroup>
																</Col>
															</Row>
														</Form.Group>
													) : (
														''
													)}
												</Col>

												{/*  */}
											</Row>
											{/* Job Description  */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Job Description{' '}
													<span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12} className='mt-4 mb-4'>
													<Form.Control
														onChange={handleChange}
														value={values.description}
														name='description'
														as='textarea'
														rows='2'
														className={`${
															errors.description && touched.description
																? 'error'
																: ''
														}`}
														placeholder='Enter text here'
													/>
													{errors.description && touched.description ? (
														<div className={`red mb-1 fs15`}>
															{errors.description}
														</div>
													) : null}
												</Col>
											</Row>

											{/* Select General & Specific Expertise */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Select General & Specific Expertise{' '}
													<span style={{ color: 'red' }}>*</span>{' '}
													<span
														style={{ fontWeight: 'bold', marginLeft: '150px' ,fontSize:'12px'}}
													>
														Note:
													</span>
													<span
														style={{ fontWeight: '600', marginLeft: '6px' , fontSize:'12px'}}
													>
														Please select at least one Primary General and one Specific Field{' '}
													</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												{/*  */}
												<Row
													style={{
														marginTop: '15px',
														marginBottom: '15px',
													}}
												>
													<Col md={4}>
														<InputGroup
															controlId='formBasicEmail'
															style={{ marginLeft: '12px' }}
														>
															<>
																<InputGroup.Text
																	className='fw-bold'
																	style={{ width: '94px' }}
																>
																	Primary <br /> General
																</InputGroup.Text>
															</>
															{/*  Parent  */}
															<ParentTagsScreen
																selectedParent={selectedParent}
																// header="Select Parent Tag"
																hideParentTag={hideParentTag}
																returnedTags={returnedTags}
																selectParentTag={selectParentTag}
																checked={checked1}
															/>
														</InputGroup>
													</Col>
													{/* 1st child */}

													<Col md={4} style={{ marginLeft: '34px' }}>
														<InputGroup controlId='formBasicEmail'>
															<>
																<InputGroup.Text className='fw-bold'>
																	Specific <br /> Field 1
																</InputGroup.Text>
															</>
															{/* /// showChildren */}
															<NewChildTag
																// header="Select Child Tag"
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags}
																childSelection={childSelection}
																selectedChild={selectedChild}
																showParent={showParent}
																childChecked={childChecked}
															/>
														</InputGroup>
													</Col>
													{/* 2nd child */}
													<Col md={3}>
														<InputGroup controlId='formBasicEmail'>
															<>
																<InputGroup.Text className='fw-bold'>
																	Specific <br /> Field 2
																</InputGroup.Text>
															</>
															{selectedChild.length >= 1 && (
																<NewChildTag
																	// header="Select Child Tag"
																	hideChildrenTag={hideChildrenTag}
																	parent={parent}
																	activeList={activeList}
																	childTags={childTags2nd}
																	childSelection={childSelection2nd}
																	selectedChild={selectedChild2nd}
																	// showParent={showParent}
																	childChecked={childChecked2nd}
																/>
															)}
														</InputGroup>
													</Col>
												</Row>
												{/* {selectedChild.length >= 1 && ( */}
												<Row
													style={{
														marginTop: '15px',
														marginBottom: '15px',
													}}
												>
													<Col md={4}>
														<InputGroup
															controlId='formBasicEmail'
															style={{ marginLeft: '10px' }}
														>
															<>
																<InputGroup.Text
																	className='fw-bold'
																	style={{ width: '96px' }}
																>
																	Secondary <br /> General
																</InputGroup.Text>
															</>
															{/*  Parent  */}
															<ParentTagsScreen
																selectedParent={selectedParent2}
																// header="Select Parent Tag"
																hideParentTag={hideParentTag}
																returnedTags={returnedTags}
																selectParentTag={selectParentTag2}
																checked={checked2}
															/>
														</InputGroup>
													</Col>
													{/* 3rd child */}
													<Col md={4} style={{ marginLeft: '32px' }}>
														<InputGroup controlId='formBasicEmail'>
															<>
																<InputGroup.Text className='fw-bold'>
																	Specific <br /> Field 1
																</InputGroup.Text>
															</>
															{/* /// showChildren */}
															<NewChildTag
																// header="Select Child Tag"
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags2}
																childSelection={childSelection2}
																showParent={showParent}
																selectedChild={selectedChild2}
																childChecked={childChecked2}
															/>
														</InputGroup>
													</Col>
													{/* 4th child */}
													<Col md={3}>
														<InputGroup controlId='formBasicEmail'>
															<>
																<InputGroup.Text className='fw-bold'>
																	Specific <br /> Field 2
																</InputGroup.Text>
															</>
															{selectedChild2.length >= 1 && (
																<NewChildTag
																	hideChildrenTag={hideChildrenTag}
																	parent={parent}
																	activeList={activeList}
																	childTags={childTags3}
																	childSelection={childSelection3}
																	// showParent={showParent}
																	selectedChild={selectedChild3}
																	childChecked={childChecked3}
																/>
															)}
														</InputGroup>
													</Col>
												</Row>

												{/* )} */}
											</Row>
											{/* Required Skills */}

											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Required Skills{' '}
													<span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12} className='mt-2'>
													<ul className='list-group list-group-flush'>
														<li className='list-group-item fw-bold'>
															{expertise?.map((item, i) => {
																return (
																	<div key={i}>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='first_name'
																				onChange={e =>
																					handleChangeMultiInput(
																						e,
																						i,
																						expertise,
																						setExpertise
																					)
																				}
																				as='textarea'
																				rows='1'
																				placeholder='Add Skills'
																				defaultValue={item}
																				value={item}
																			/>
																		</Form.Group>
																		<div className='btn-box'>
																			{/* <Button variant="outline-success">Success</Button> */}
																			{expertise.length !== 1 && (
																				<Button
																					variant='outline-danger'
																					style={{
																						marginRight: '48px',
																						marginBottom: '6px',
																					}}
																					onClick={() =>
																						handleRemove(
																							i,
																							expertise,
																							setExpertise
																						)
																					}
																				>
																					Remove this Required Skills
																				</Button>
																			)}
																			{expertise.length - 1 === i &&
																				expertise.length < 10 && (
																					<Button
																						className='mt-3 mb-2'
																						variant='outline-success'
																						onClick={() =>
																							setExpertise([...expertise, ''])
																						}
																					>
																						Add Skills
																					</Button>
																				)}
																		</div>
																	</div>
																);
															})}
														</li>
													</ul>
												</Col>
											</Row>
											{/* Recommended Skills */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Recommended Skills
													<span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12} className='mt-2'>
													<ul className='list-group list-group-flush'>
														<li className='list-group-item fw-bold'>
															{otherRequirements.map((item, i) => {
																return (
																	<div key={i}>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='requirement'
																				onChange={e =>
																					handleChangeMultiInput(
																						e,
																						i,
																						otherRequirements,
																						setOtherRequirements
																					)
																				}
																				as='textarea'
																				rows='1'
																				placeholder='Add Tool'
																				defaultValue={item}
																				value={item}
																			/>
																		</Form.Group>
																		<div className='btn-box'>
																			{otherRequirements?.length !== 1 && (
																				<Button
																					variant='outline-danger'
																					style={{
																						marginRight: '48px',
																						marginBottom: '6px',
																					}}
																					onClick={() =>
																						handleRemove(
																							i,
																							otherRequirements,
																							setOtherRequirements
																						)
																					}
																				>
																					Remove this Tool
																				</Button>
																			)}
																			{otherRequirements.length - 1 === i &&
																				otherRequirements.length < 10 && (
																					<Button
																						className='mt-3 mb-2'
																						variant='outline-success'
																						onClick={() =>
																							setOtherRequirements([
																								...otherRequirements,
																								'',
																							])
																						}
																					>
																						Add Tools
																					</Button>
																				)}
																		</div>
																	</div>
																);
															})}
														</li>
													</ul>
												</Col>
											</Row>
											{/* Tool Required/Recommended */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Tool Required/Recommended
													<span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
													marginBottom: '15px',
												}}
											>
												<Col sm={12} className='mt-2'>
													<ul className='list-group list-group-flush'>
														<li className='list-group-item fw-bold'>
															{tools?.map((item, i) => {
																return (
																	<div key={i}>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='tools'
																				onChange={e =>
																					handleChangeMultiInput(
																						e,
																						i,
																						tools,
																						setTools
																					)
																				}
																				as='textarea'
																				rows='1'
																				placeholder='Add Skills'
																				defaultValue={item}
																				value={item}
																			/>
																		</Form.Group>
																		<Row className='mt-3 mb-2'>
																			<Col sm={6}>
																				<InputGroup
																					controlId='formBasicEmail'
																					className='mb-4'
																				>
																					<>
																						<InputGroup.Text className='fw-bold'>
																							Must Own Tools:
																						</InputGroup.Text>
																					</>

																					<Form.Control
																						as='select'
																						onChange={handleChange}
																					>
																						<option value='' disabled selected>
																							Select Options
																						</option>
																						<option value='Yes'>Yes</option>
																						<option value='No'>No</option>
																					</Form.Control>
																				</InputGroup>
																			</Col>
																			<Col sm={6}>
																				<InputGroup
																					controlId='formBasicEmail'
																					className='mb-2'
																				>
																					<>
																						<InputGroup.Text className='fw-bold'>
																							Clint Provides Tool:
																						</InputGroup.Text>
																					</>

																					<Form.Control
																						as='select'
																						onChange={handleChange}
																					>
																						<option value='' disabled selected>
																							Select Options
																						</option>
																						<option value='Yes'>Yes</option>
																						<option value='No'>No</option>
																						<option value='may_be'>
																							May be
																						</option>
																					</Form.Control>
																				</InputGroup>
																			</Col>
																		</Row>
																		<div className='btn-box'>
																			{tools?.length !== 1 && (
																				<Button
																					variant='outline-danger'
																					style={{
																						marginRight: '48px',
																						marginBottom: '6px',
																					}}
																					onClick={() =>
																						handleRemove(i, tools, setTools)
																					}
																				>
																					Remove this Recommended Skills
																				</Button>
																			)}
																			{tools.length - 1 === i &&
																				tools.length < 10 && (
																					<Button
																						variant='outline-success'
																						onClick={() =>
																							setTools([...tools, ''])
																						}
																					>
																						Add Skills
																					</Button>
																				)}
																		</div>
																	</div>
																);
															})}
														</li>
													</ul>
												</Col>
											</Row>
										</Form>
										{/* Location/Meeting/Travel */}
										<Form style={{ border: '1px solid', marginTop: '12px' }}>
											<Row>
												<Col sm={12}>
													<div
														className={'top-actions bg-label'}
														style={{ borderBottom: ' 1px solid' }}
													>
														<h4
															className={
																'heading text-orange fw-bold p-2 ms-2 rounded'
															}
														>
															Location/Meeting/Travel
														</h4>
													</div>
												</Col>
											</Row>

											{/* Location  */}
											<Row
												className='bg-label'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Location <span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12} className='mt-3 ms-5  '>
													<Stack
														direction={'row'}
														gap={2}
														key={`custom-inline-checkbox`}
													>
														<label className='radiobox-flex'>
															<Field
																type='radio'
																className='radiobox'
																name='job_location'
																value='onsite'
															/>
															<span>On-Site</span>
														</label>

														<label className='radiobox-flex'>
															<Field
																type='radio'
																className='radiobox'
																name='job_location'
																value='remote'
															/>
															<span> Remote </span>
														</label>

														<label className='radiobox-flex'>
															<Field
																type='radio'
																className='radiobox'
																name='job_location'
																value='both'
															/>
															<span> Both </span>
														</label>

														{errors.job_location && touched.job_location ? (
															<div className={`red mb-1 fs15`}>
																{errors.job_location}
															</div>
														) : null}
													</Stack>
												</Col>
											</Row>
											{/* On-Site Meetings Required */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													On-Site Meetings Required{' '}
													<span style={{ color: 'red' }}>*</span>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
												}}
											>
												<Col sm={12} className='mt-3 ms-5 '>
													<Stack
														direction={'row'}
														gap={2}
														key={`custom-inline-checkbox`}
													>
														<label className='radiobox-flex'>
															<Field
																type={'radio'}
																className='radiobox'
																name='onsite_meetings'
																value='yes'
																onChange={handleChange}
															/>
															<span> Yes </span>
														</label>

														<label className='radiobox-flex'>
															<Field
																type={'radio'}
																className='radiobox'
																name='onsite_meetings'
																value='no'
																onChange={handleChange}
															/>
															<span> No </span>
														</label>

														{errors.onsite_meetings &&
														touched.onsite_meetings ? (
															<div className={`red mb-1 fs15`}>
																{errors.onsite_meetings}
															</div>
														) : null}
													</Stack>
												</Col>
											</Row>
											{/* Requires Travel */}
											<Row
												className='bg-label mt-4'
												style={{
													width: '98.6%',
													marginLeft: '15px',
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													borderTop: ' 1px solid',
												}}
											>
												<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
													{' '}
													Requires Travel
													{/* <span style={{ color: "red" }}>*</span> */}
													<Form.Check
														style={{ marginLeft: '10px' }}
														size='lg'
														custom
														inline
														type='switch'
														id='custom-switch'
														name='requires_travel'
														checked={values.requires_travel ? true : false}
														label=''
														onChange={() =>
															setFieldValue(
																'requires_travel',
																!values.requires_travel
															)
														}
													/>
												</Col>
											</Row>
											<Row
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '15px',
													marginBottom: '18px',
												}}
											>
												<Col sm={12} className='mt-3 ms-1 '>
													{values.requires_travel ? (
														<Form.Group
															controlId='newJobDestination'
															className='ms-5'
														>
															<Stack
																direction={'row'}
																gap={2}
																key={`custom-inline-checkbox`}
															>
																<label className='radiobox-flex'>
																	<Field
																		type='radio'
																		className='radiobox'
																		name='travel_type'
																		onChange={handleChange}
																		value='InState'
																	/>
																	<span> In State </span>
																</label>

																<label className='radiobox-flex'>
																	<Field
																		type='radio'
																		className='radiobox'
																		name='travel_type'
																		onChange={handleChange}
																		value='Domestic'
																	/>
																	<span> Domestic (US Only) </span>
																</label>

																<label className='radiobox-flex'>
																	<Field
																		type='radio'
																		className='radiobox'
																		name='travel_type'
																		onChange={handleChange}
																		value='International'
																	/>
																	<span> International </span>
																</label>

																{errors.travel_type && touched.travel_type ? (
																	<div className={`red mb-1 fs15`}>
																		{errors.travel_type}
																	</div>
																) : null}
															</Stack>

															<Row>
																<Col>
																	<Form.Control
																		value={values.destination}
																		name='destination'
																		onChange={handleChange}
																		rows='1'
																		as='textarea'
																		placeholder='Enter destination here'
																	/>
																	<span
																		style={{
																			fontSize: '12px',
																			color: '#007bff',
																			fontWeight: 700,
																			width: '60px',
																		}}
																	>
																		<b>
																			<u>Info:</u>
																		</b>
																		<br />
																		Please add City, State and/or Country” “If
																		adding multiple locations place a semicolon
																		‘;’ between locations.
																	</span>
																</Col>
																<Col md='auto'>
																	<Form.Label className='mt-2 text-orange'>
																		Duration of Travel
																	</Form.Label>
																</Col>
																<Col xs lg='2'>
																	<Form.Control
																		value={values.travel_duration}
																		onChange={handleChange}
																		name='travel_duration'
																		type='number'
																		min='0'
																		oninput='this.value = Math.abs(this.value)'
																		placeholder={'Duration'}
																	/>
																</Col>
															</Row>

															<Row>
																<Col>
																	<Form.Control
																		// name="abc"
																		style={{ display: 'none' }}
																	/>
																</Col>
																<Col md='auto' className='mb-3'>
																	<Form.Label className='mt-2 text-orange'>
																		Approx. Duration of Travel
																	</Form.Label>
																</Col>
																<Col xs lg='2'>
																	<Form.Group controlId='newJobPrioLevel'>
																		<Form.Control
																			as='select'
																			custom
																			name='approx_duration'
																			onChange={handleChange}
																			placeholder='Select approx. duration of travel'
																			required
																		>
																			<option value='10'>10</option>
																			<option value='20'>20</option>
																			<option value='30'>30</option>
																			<option value='40'>40</option>
																			<option value='50'>50</option>
																			<option value='60'>60</option>
																			<option value='70'>70</option>
																			<option value='80'>80</option>
																			<option value='90'>90</option>
																			<option value='100'>100</option>
																		</Form.Control>
																	</Form.Group>
																</Col>
															</Row>
														</Form.Group>
													) : (
														''
													)}
												</Col>
											</Row>
										</Form>

										<div className={'text-center mt-4'}>
											<Button
												onClick={() => handleButtonClick(submitForm)}
												className='btn-new-client btn-orange'
											>
												<PlusCircleIcon size={16} /> Save to Draft
											</Button>
										</div>
									</Form>
								)}
							</Formik>
						) : (
							''
						)}
					</Col>
				</Row>
				<div style={{ height: '142px' }} />
			</Container>
			<Footer />
		</Container>
	);
}

export default EditJob;
